import AtomTooltip from '@s-ui/react-atom-tooltip'
import {useSuiContext} from '@s-ui/react-context'
import IconInfoOutline from '@adv-mt/mt-svg-icons/lib/InfoOutline'

import SortManagementInfoContent from './sortManagementInfoContent.js'

const TOOLTIP_ID = 'search-sort-management-info-tooltip'

const SearchSortManagementInfo = () => {
  const {i18n} = useSuiContext()

  return (
    <div className="mt-SearchSortManagementInfo">
      <AtomTooltip content={<SortManagementInfoContent />} id={TOOLTIP_ID}>
        <div
          aria-describedby={TOOLTIP_ID}
          aria-label={i18n.t('NOTIFICATIONS.SORT_MANAGEMENT_NOTIFICATION.LABEL')}
          className="mt-SearchSortManagementInfo-icon"
          role="button"
        >
          <IconInfoOutline />
        </div>
      </AtomTooltip>
    </div>
  )
}

SearchSortManagementInfo.displayName = 'SearchSortManagementInfo'

export default SearchSortManagementInfo
